<div class="dialog">
  <mat-accordion>

    <mat-expansion-panel hideToggle [expanded]="panelExpanded" disabled [ngStyle]="{'width': width}">
      <mat-expansion-panel-header>

        <mat-panel-title>

          <div class="title-and-micro">

          </div>

          <div class="question-title-section">

            <span class="title-style">
              {{ title }}
            </span>
            @if (isFirstQuestionnaire && isFirstQuestionnaire === true){
            <span class="label" [class.valid]="valid" [class.invalid]="!valid">
            </span>
            }

          </div>

          <app-microphone (voice)="recebeVoice($event)">
          </app-microphone>


          <app-radio-button class="radio-btn" [multipleRadios]="true" (select)="itemSelected($event)"
            [valueBiding]="radioValue" [name]="title" [items]="optionsLabels ">
          </app-radio-button>

        </mat-panel-title>



        <button mat-icon-button (click)="panelExpanded = !panelExpanded">
          <img src="assets/icons/expand_icon.svg">
        </button>

      </mat-expansion-panel-header>

      <textarea id="myTextarea" class="input-text" (input)="autoResize($event)" [formControl]="inputText"
        [ngStyle]="applyHeight()">
      </textarea>

    </mat-expansion-panel>
  </mat-accordion>
</div>
